import { FC } from 'react';
import IcoStarsOutline from '@/assets/svg/ico_stars_outline.svg?react';
import Button from '@/components/controls/Button/Button.component';
import ModalSheet from '@/components/interactive/ModalSheet/ModalSheet.component';
import { MODAL_SHEET_SIZES } from '@/components/interactive/ModalSheet/ModalSheet.config';
import styles from '@/components/widgets/ProgressWidget/LoadStartModal/LoadStartModal.module.scss';
import { LoadStartModalPropsIF } from '@/components/widgets/ProgressWidget/LoadStartModal/LoadStartModal.types';

const LoadStartModal: FC<LoadStartModalPropsIF> = ({ onclose }) => (
    <ModalSheet
        size={MODAL_SHEET_SIZES.Small}
        onClose={onclose}
        isHideClose
        dataTest="load_start_modal"
    >
        <div className={`flcol flc ${styles.modalBody}`}>
            <IcoStarsOutline />
            <span className={styles.content}>
                Можно продолжать работу
                <br /> в приложении, пока ваши
                <br /> изделия обрабатываются
            </span>
            <Button
                dataTest="load_start_close_button"
                clickHandler={() => onclose()}
            >
                Понятно
            </Button>
        </div>
    </ModalSheet>
);

export default LoadStartModal;
